import React from "react";
import { NextPage } from "next";

import Contact from "scenes/Contact";

const Index: NextPage = () => <Contact />;

export default Index;
